//const token = localStorage.apiCredentials;
//const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
import ds from '../services/DataSourceService'

export const AuthImage = {}
const isUrl = string => {
  try {
    return Boolean(new URL(string))
  } catch (e) {
    return false
  }
}

const setImgSrc = async (el, binding) => {
  // try {
  // 	console.log("SRC ", src);
  // 	const imageBlob = ds.get(src, { headers, responseType: "blob" });
  // 	const reader = new FileReader();
  // 	console.log("NAPRAVIT CU $CENU");
  // 	return new Promise((resolve, reject) => {
  // 		reader.onloadend = () => resolve(reader.result);
  // 		reader.readAsDataURL(imageBlob);
  // 	});
  // } catch {
  // 	return "assets/fallback.png";
  // }

  if (binding.value === './assets/default_file_icon.png') {
    console.log('FILE')
    el.src = require('../assets/default_file_icon.png')
    return
  } else if (isUrl(binding.value)) {
    console.log('IS URL')
    el.src = binding.value
    console.log('URL : ', el.src)
    return
  } else if (binding.value !== undefined && binding.value !== '') {
    var imageUrl = binding.value
    await ds
      .apiClientThinkHome({
        method: 'get',
        url: imageUrl,
        responseType: 'arraybuffer'
      })
      .then(function(resp) {
        var mimeType = resp.headers['content-type'].toLowerCase()
        var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
        el.src = 'data:' + mimeType + ';base64,' + imgBase64
        console.log('FILE HERE : ')
      })
      .catch(function() {
        el.src = imageUrl
      })
  }
}

export default {
  setImgSrc
}
